import React, { useEffect } from 'react'
import './ProductSlide.scss'
import { AiFillEye } from 'react-icons/ai';
import { DM } from "./../../Data"
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProductSlide = () => {


    return (
        <>
            <div className="ProductSlide-container">
                <div className="ProductSlider" >
                    {DM.map((url) => (
                        <div className="ProductSlider-item" key={url.id}>
                             <Link to ="/product">

                            <div
                                className="ProductSlider-item-image"
                                style={{ backgroundImage: `url(${url.src})` }}
                                >
                                <motion.div
                                    whileHover={{ opacity: [1, 0] }}
                                    transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                                    className="DM-hover app__flex"
                                    >
                                    
                                     <motion.div
                                            whileInView={{ scale: [0, 1] }}
                                            whileHover={{ scale: [1, 0.90] }}
                                            transition={{ duration: 0.25 }}
                                            className="app__flex"
                                            >
                                            <AiFillEye />
                                        </motion.div>
                                    
                                </motion.div>
                            </div>
                            </Link>
                        
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};


export default ProductSlide
